//icons
import {
  TelegramFillIcon,
  TeamsIcon,
  LinkedinIcon,
  InstagramIcon,
  FacebookIcon,
} from "../components/UI/Icons";

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';

export type SocialsLinkType = {
  title: string;
  url: string;
  Icon: any;
};

interface IBrandLinks {
  [key: string]: {
    socials: SocialsLinkType[];
    email: string;
    bot?: string;
  }
}

export const brandLinks: IBrandLinks = {
  pma: {
    socials: [
      {
        title: "Linkedin",
        url: "https://www.linkedin.com/company/pmaffiliates/",
        Icon: LinkedinIcon,
      },
      {
        title: "Telegram",
        url: "https://t.me/Pmaffiliates",
        Icon: TelegramFillIcon,
      },
      {
        title: "Instagram",
        url: "https://www.instagram.com/parimatch.affiliates_global/",
        Icon: InstagramIcon,
      },
      /*{
        title: "Facebook",
        url: "https://www.facebook.com/parimatch.affiliates",
        Icon: FacebookIcon,
      },
      {
        title: "Skype",
        url: "skype:partners.parimatch.com?chat",
        Icon: TeamsIcon,
      },*/
    ],
    bot: "https://t.me/Pmaffiliates",
    email: "affhelp@pm.bet",
  },
  pkmp: {
    socials: [
      {
        title: "Telegram",
        url: "https://t.me//Pokerbet_partners",
        Icon: TelegramFillIcon,
      },
    ],
    email: "aff@poker-bet.com",
  },
  btrp: {
    socials: [
      {
        title: "Teams",
        url: "teams:partners.parimatch.com?chat",
        Icon: TeamsIcon,
      },
    ],
    email: "affhelp@btrp.bet",
  },
  flxp: {
    socials: [
      {
        title: "Teams",
        url: "teams:partners.parimatch.com?chat",
        Icon: TeamsIcon,
      },
    ],
    email: "affhelp@flxp.bet",
  },
  afft: {
    socials: [
      {
        title: "Facebook",
        url: "https://www.facebook.com/affter.aff/",
        Icon: FacebookIcon,
      },
      {
        title: "Instagram",
        url: "https://www.instagram.com/_affter/",
        Icon: InstagramIcon,
      },
      {
        title: "Telegram",
        url: "https://t.me/affter_support",
        Icon: TelegramFillIcon,
      },
      {
        title: "Linkedin",
        url: "https://www.linkedin.com/company/affter/",
        Icon: LinkedInIcon,
      },
    ],
    email: "support@affter.com",
  },
  grp: {
    socials: [
      {
        title: "Linkedin",
        url: "https://www.linkedin.com/company/growe-partners/",
        Icon: LinkedInIcon,
      },
      {
        title: "Telegram",
        url: "https://t.me/growepartners_support",
        Icon: TelegramFillIcon,
      },
      {
        title: "Instagram",
        url: "https://www.instagram.com/growe.partners/",
        Icon: InstagramIcon,
      },
    ],
    //bot: "https://t.me/Pmaffiliates",
    email: "support@growe.partners",
  },
  bat: {
    socials: [
      {
        title: "Teams",
        url: "teams:partners.parimatch.com?chat",
        Icon: TeamsIcon,
      },
    ],
    email: "support@boringagency.tech",
  },
  mjp: {
    socials: [],
    email: "support@playpulse.agency",
  },
  wno: {
    socials: [],
    //bot: "https://t.me/Pmaffiliates",
    email: "support@win-offers.com",
  },
  plds: {
    socials: [],
    //bot: "https://t.me/Pmaffiliates",
    email: "support@support.playdash.one",
  },
  gca: {
    socials: [
      /*{
        title: "Telegram",
        url: "https://t.me/BAgent_PM",
        Icon: TelegramFillIcon,
      },*/
    ],
    email: "affiliates@gorilla.ua",
  },
  lxa: {
    socials: [
      /*{
        title: "Telegram",
        url: "https://t.me/BAgent_PM",
        Icon: TelegramFillIcon,
      },*/
    ],
    email: "support@luxaffs.com",
  },
  mbp: {
    socials: [],
    //bot: "https://t.me/Pmaffiliates",
    email: "support@moonpartner.net",
  },
  btwnp: {
    socials: [],
    email: "servicio-al-cliente@beton.win",
  },
  joinb: {
    socials: [
      {
        title: "Telegram",
        url: "http://t.me/joinbetcom",
        Icon: TelegramFillIcon,
      },
      {
        title: "Instagram",
        url: "http://instagram.com/joinbetcom",
        Icon: InstagramIcon,
      },
    ],
    email: "support@joinbet.partners",
  },
  pmaff: {
    socials: [
      {
        title: "Linkedin",
        url: "https://www.linkedin.com/company/parimatchaffiliates/",
        Icon: LinkedinIcon,
      },
      {
        title: "Telegram",
        url: "https://t.me/pmaffiliates_channel",
        Icon: TelegramFillIcon,
      },
      {
        title: "Instagram",
        url: "https://www.instagram.com/parimatch_aff/",
        Icon: InstagramIcon,
      },
    ],
    email: "contact@pmaffiliates.com",
  },
  btfp: {
    socials: [
      {
        title: "Instagram",
        url: "https://www.instagram.com/betfury.chile",
        Icon: InstagramIcon,
      },
      {
        title: "Facebook",
        url: "https://www.facebook.com/betfury.chile",
        Icon: FacebookIcon,
      },
    ],
    email: "partners@betfury.cl",
  },
  frgp: {
    socials: [],
    email: "alexander@fragabet.com",
  },
  msla: {
    socials: [],
    email: "destek@maxislot.com",
  },
  odag: {
    socials: [],
    email: "support@oddami.com",
  },
  fbta: {
    socials: [],
    email: "affiliates@firstbet.com",
  },
  lxbp: {
    socials: [],
    email: "support@harakabetpartners.com",
  },
  vph: {
    socials: [],
    email: "support@viphouse.com",
  },
  mrkp: {
    socials: [],
    email: "support@daleafiliados.com",
  },
  spna: {
    socials: [],
    email: "support@spinova-agents.com",
  },
  nwnp: {
    socials: [],
    email: "destek@nowin724.com",
  },
  btza: {
    socials: [],
    email: "info@betazor.com",
  },
  stpr: {
    socials: [],
    email: "support@slot.partners",
  },
  gnbt: {
    socials: [],
    email: "gonemedia850@gmail.com",
  },
  khlp: {
    socials: [],
    email: "support@kheleads.com",
  },
  alfwn: {
    socials: [],
    email: "support@alfwin.com",
  },
  ownbt: {
    socials: [],
    email: "support@owinbet.com",
  },
  lirv: {
    socials: [],
    email: "support@yallabom.com",
  },
  koor: {
    socials: [],
    email: "support@amarabet.com",
  },
	lrma: {
		socials: [],
		email: "support@liramatic.com",
	},
  slpkng: {
		socials: [],
		email: "affiliates@slapkong.com",
	},
	bsba: {
		socials: [],
		email: "support@basibet.com",
	},
	pmthagnt: {
		socials: [],
		email: "",
	},
	rooag: {
		socials: [],
		email: "support@roobet24.com",
	},
	aypr: {
		socials: [],
		email: "affiliate@spinay.partners",
	},
	turx: {
		socials: [],
		email: "partners.turix@support.com",
	},
	orbt: {
		socials: [],
		email: "support@orobet365.com",
	},
  mngd: {
		socials: [],
		email: "affiliate@mangodorado.com",
	},
  pmvip: {
		socials: [],
		email: "vip@parimatch.com",
	},
  crpb: {
		socials: [],
		email: "support@crypbet365.com",
	},
  nvdp: {
		socials: [],
		email: "affiliates@nevada-partners.com",
	},
  betb: {
		socials: [],
		email: "destek@betbob.com",
	},
	ldrbt: {
		socials: [],
		email: "info@ledraortak.com",
	},
  mpma: {
		socials: [],
		email: "",
	},
  ripa: {
		socials: [],
		email: "support@kedi.bet",
	},
  betx: {
		socials: [],
		email: "info@betxortak.com",
	},
  bnfp: {
		socials: [],
		email: "betnofest@gmail.com",
	},
  cupa: {
		socials: [],
		email: "rmarakhovskyi@gmail.com",
	},
  redf: {
		socials: [],
		email: "affiliates@redslot.com",
	},
  cmdf: {
		socials: [],
		email: "affiliate@chamada.bt",
	},
  rupa: {
		socials: [],
		email: "info@rulettopartner.com",
	},
  stkd: {
    socials: [],
    email: "info@stakeduelpartners.com",
  },
	ggpa: {
		socials: [],
		email: "aff@ggpartners.pro",
	},
	usta: {
		socials: [],
		email: "affiliate@ustaortaklar.com",
	},
  chsp: {
		socials: [],
		email: "partners@chainspin.com",
	},
  oddx: {
		socials: [],
		email: "support@oddx.partners",
	},
  fame: {
		socials: [],
		email: "info@famecasino.com",
	},
  infl: {
		socials: [],
		email: "support@influ.partners",
	},
  gobe: {
		socials: [],
		email: "support@goalbet24.com",
	},
	capo: {
		socials: [],
		email: "support@caposino.com",
	},
	frst: {
		socials: [],
		email: "adv@first.ua",
	},
	hala: {
		socials: [],
		email: "support@1000halla.com",
	},
}
